{
  "name": "customer-portal-ui",
  "version": "3.15.1",
  "license": "MIT",
  "scripts": {
    "ng-openapi-gen": "ng-openapi-gen",
    "ng": "ng",
    "clean": "rimraf dist && rimraf node_modules",
    "prebuild": "rimraf dist && node src/tools/update-version.js",
    "start": "ng serve --host 0.0.0.0 --disable-host-check --proxy-config proxy.conf.json",
    "start-ssl": "ng serve --host 0.0.0.0 --disable-host-check --proxy-config proxy.conf-ssl.json --ssl true --ssl-key ../customer-portal-docker-dev-environment/nginx/certbot/conf/live/pbx-events.codaker.dev/privkey.pem --ssl-cert ../customer-portal-docker-dev-environment/nginx/certbot/conf/live/pbx-events.codaker.dev/fullchain.pem",
    "build": "node --max_old_space_size=8000 ./node_modules/@angular/cli/bin/ng build --configuration=staging --stats-json && gzipper compress ./dist",
    "build-prod": "npm run update-random-version && node --max_old_space_size=8000 ./node_modules/@angular/cli/bin/ng build --configuration=production && gzipper compress ./dist",
    "build:staging": "npm run update-random-version && node --max_old_space_size=8000 ./node_modules/@angular/cli/bin/ng build --configuration=staging --stats-json && gzipper compress ./dist",
    "build:stats": "ng build --configuration=production --stats-json",
    "analyze": "webpack-bundle-analyzer dist/stats.json",
    "gzipper": "gzipper",
    "compress": "gzipper compress ./dist",
    "update-random-version": "node src/tools/update-version-random.js",
    "build-docker-image": "docker build -t gcr.io/bo-farm/customer-portal-web:%npm_package_version% .",
    "deploy-image": "docker build -t gcr.io/bo-farm/customer-portal-web:%npm_package_version% . & gcloud docker -- push gcr.io/bo-farm/customer-portal-web:%npm_package_version%",
    "deploy-k8s": "kubectl apply -f deployments/k8s.development.yaml",
    "iis-copy": "copy-iis-deploy.cmd",
    "test": "ng test",
    "lint": "ng lint",
    "e2e": "ng e2e"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "18.2.13",
    "@angular/cdk": "18.2.14",
    "@angular/cdk-experimental": "18.2.14",
    "@angular/common": "18.2.13",
    "@angular/compiler": "18.2.13",
    "@angular/core": "18.2.13",
    "@angular/flex-layout": "15.0.0-beta.42",
    "@angular/forms": "18.2.13",
    "@angular/localize": "18.2.13",
    "@angular/material": "18.2.14",
    "@angular/material-moment-adapter": "18.2.14",
    "@angular/platform-browser": "18.2.13",
    "@angular/platform-browser-dynamic": "18.2.13",
    "@angular/router": "18.2.13",
    "@dagrejs/dagre": "^1.1.4",
    "@foblex/core": "1.2.6",
    "@foblex/flow": "17.4.3",
    "@foblex/flow-animator": "16.1.0",
    "@fortawesome/fontawesome-free": "6.7.2",
    "@ng-matero/extensions": "18.5.0",
    "@ng-matero/extensions-moment-adapter": "18.0.0",
    "@ngxmc/datetime-picker": "18.2.2",
    "@primeng/themes": "18.0.2",
    "angular-gridster2": "18.0.1",
    "angular2-promise-buttons": "6.0.0",
    "bootstrap": "5.3.5",
    "check-browser": "0.1.7",
    "core-js": "3.41.0",
    "crypto-js": "4.2.0",
    "date-time-format-timezone": "1.0.22",
    "echarts": "5.6.0",
    "echarts-simple-transform": "1.0.0",
    "font-awesome": "4.7.0",
    "hammerjs": "2.0.8",
    "intl": "1.2.5",
    "libphonenumber-js": "1.12.6",
    "lodash": "4.17.21",
    "luxon": "3.6.1",
    "lz-string": "1.5.0",
    "moment": "2.30.1",
    "moment-timezone": "0.5.48",
    "ngx-color-picker": "18.0.0",
    "ngx-cookie-service": "18.0.0",
    "ngx-echarts": "18.0.0",
    "ngx-json-viewer": "3.2.1",
    "pdfjs-dist": "5.1.91",
    "pdfmake": "0.2.18",
    "primeicons": "7.0.0",
    "primeng": "18.0.2",
    "rrule": "2.8.1",
    "rxjs": "7.8.2",
    "socket.io-client": "4.8.1",
    "twix": "1.3.0",
    "zone.js": "0.14.10"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "18.2.18",
    "@angular-devkit/schematics": "18.2.18",
    "@angular-eslint/builder": "18.4.3",
    "@angular-eslint/eslint-plugin": "18.4.3",
    "@angular-eslint/eslint-plugin-template": "18.4.3",
    "@angular-eslint/schematics": "18.4.3",
    "@angular-eslint/template-parser": "18.4.3",
    "@angular/cli": "18.2.18",
    "@angular/compiler-cli": "18.2.13",
    "@angular/language-service": "18.2.13",
    "@eslint/eslintrc": "^3.3.1",
    "@eslint/js": "^9.24.0",
    "@types/crypto-js": "4.2.2",
    "@types/facebook-js-sdk": "3.3.12",
    "@types/google.analytics": "0.0.46",
    "@types/jasmine": "5.1.7",
    "@types/lodash": "4.17.16",
    "@types/luxon": "3.6.2",
    "@types/node": "22.14.1",
    "@types/pdfmake": "0.2.11",
    "@types/twix": "0.6.42",
    "@typescript-eslint/eslint-plugin": "8.30.1",
    "@typescript-eslint/parser": "8.30.1",
    "eslint": "9.24.0",
    "gzipper": "8.2.1",
    "jasmine-core": "5.6.0",
    "jasmine-marbles": "0.9.2",
    "jasmine-spec-reporter": "7.0.0",
    "karma": "6.4.4",
    "karma-chrome-launcher": "3.2.0",
    "karma-coverage": "2.2.1",
    "karma-jasmine": "5.1.0",
    "karma-jasmine-html-reporter": "2.1.0",
    "ng-openapi-gen": "0.53.0",
    "prettier": "3.5.3",
    "resize-observer-polyfill": "1.5.1",
    "sass": "1.86.3",
    "ts-node": "10.9.2",
    "tslib": "2.8.1",
    "typescript": "5.4.5"
  }
}
